import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { TeachersCommentsService } from '../../services/teachers-comments.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { TeacherComment } from '../../models/teacher-comment';

@Component({
  selector: 'app-teachers-comments-details',
  templateUrl: './teachers-comments-details.component.html',
  styleUrls: ['./teachers-comments-details.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class TeachersCommentsDetailsComponent extends ComponentBase implements OnInit {

  constructor(private teachersCommentsService: TeachersCommentsService) {
    super();
  }

  @Input() comment: TeacherComment

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.comment) {
      if (!this.comment.is_read_by_person) {
        let subscription = this.teachersCommentsService.markTeachersCommentAsRead(this.comment.comment_id)
          .subscribe(res => {
            this.comment.is_read_by_person = true;
          });
        this.addSubscription(subscription);
      }
    }
  }
}
